const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  mediaBaseUrl: import.meta.env.VITE_MEDIA_BASE_URL,
  clientBaseUrl: import.meta.env.VITE_CLIENT_BASE_URL,
  twitchParentDomain: import.meta.env.VITE_TWITCH_PARENT_DOMAIN || '',
  // PostHog (ENG-857): analytics stay off, with no PostHog call at all, while
  // the key is unset (local development).
  posthogKey: import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
  // The frontend build version, once the deploy stamps one (ENG-848).
  appVersion: import.meta.env.VITE_APP_VERSION || '',
  defaultTheme: 'songshake',
};

export default config;
